import React from 'react';

import { PendingBar } from './styles';

/**
 * El hueco de una miga cuyo ROID todavía no ha llegado.
 *
 * ── Por qué una barra y no «…», ni nada ────────────────────────────────────
 *
 * En una miga de pan los puntos suspensivos YA significan otra cosa: son el
 * patrón estándar del camino plegado ("hay más niveles aquí, tócame"), y en
 * varios sistemas de diseño son un elemento interactivo que despliega los
 * niveles ocultos. Usarlos para "cargando" invita a tocar algo que no hace
 * nada.
 *
 * Y dejarlo vacío tampoco: el hueco se cierra, el separador queda colgando y
 * cuando entra el ROID toda la miga se desplaza — el salto de layout que los
 * esqueletos existen precisamente para evitar.
 *
 * Así que una barra del ancho aproximado de un ROID (`Ot.0000338.0000.01`).
 * Reserva su sitio, no promete nada que no vaya a pasar y se lee como lo que
 * es. Sin animación a propósito: vive entre 150 ms y un segundo, y un
 * parpadeo ahí es ruido.
 */
export const PendingCrumb = (): JSX.Element => (
  <PendingBar aria-busy="true" aria-label="…" />
);
